import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { botService } from "../services/svc_bots";
import { queryKeys } from "../lib/queryKeys";

export const useTSQFetchBotList = (
  skip?: number,
  limit?: number,
  active_only?: boolean,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: queryKeys.bots.lists(),
    queryFn: () => botService.list(skip, limit, active_only),
    enabled: enabled,
  });
};

/**
 * Custom hook for creating Bot Token
 */
export const useTSMCreateBotToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: botService.create,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.bots.lists(),
      });
    },
    onError: (error) => {
      console.error("Bot Token Creation failed:", error);
    },
  });
};

/**
 * Custom hook for creating Bot Token
 */
export const useTSMDeactivateBotToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: botService.deactivate,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.bots.lists(),
      });
    },
    onError: (error) => {
      console.error("Bot Token Deactivation Failed:", error);
    },
  });
};
export const useTSMReactivateBotToken = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: botService.reactivate,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.bots.lists(),
      });
    },
    onError: (error) => {
      console.error("Bot Token Reactivation Failed:", error);
    },
  });
};
